export default __webpack_public_path__ + "static/media/organic-pasture.0d4a2f44.png";